var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "ms_header_downside" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "tokutei" } },
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("特定商取引法の表示")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "mokuji" }, [
                    _c("li", [_vm._v("目次")]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.scrollToAnchorPoint("corp_domans")
                            }
                          }
                        },
                        [_vm._v("ドゥーマンズ株式会社")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.scrollToAnchorPoint("corp_funiturmaker")
                            }
                          }
                        },
                        [_vm._v("ファニチャーメーカー株式会社")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.scrollToAnchorPoint("corp_miura")
                            }
                          }
                        },
                        [_vm._v("株式会社みうら")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.scrollToAnchorPoint("corp_candeal")
                            }
                          }
                        },
                        [_vm._v("株式会社キャンディルテクト")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.scrollToAnchorPoint("corp_axis")
                            }
                          }
                        },
                        [_vm._v("アクシス株式会社")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.scrollToAnchorPoint("corp_tecma")
                            }
                          }
                        },
                        [_vm._v("株式会社テクマ")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { ref: "corp_domans", staticClass: "corp_table" }, [
                    _c("div", [_vm._v("ドゥーマンズ株式会社")]),
                    _vm._v(" "),
                    _vm._m(0)
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { ref: "corp_funiturmaker", staticClass: "corp_table" },
                    [
                      _c("div", [_vm._v("ファニチャーメーカー株式会社")]),
                      _vm._v(" "),
                      _vm._m(1)
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { ref: "corp_miura", staticClass: "corp_table" }, [
                    _c("div", [_vm._v("株式会社みうら")]),
                    _vm._v(" "),
                    _vm._m(2)
                  ]),
                  _vm._v(" "),
                  _c("div", { ref: "corp_axis", staticClass: "corp_table" }, [
                    _c("div", [_vm._v("アクシス株式会社")]),
                    _vm._v(" "),
                    _vm._m(3)
                  ]),
                  _vm._v(" "),
                  _c("div", { ref: "corp_tecma", staticClass: "corp_table" }, [
                    _c("div", [_vm._v("株式会社テクマ")]),
                    _vm._v(" "),
                    _vm._m(4)
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { ref: "corp_candeal", staticClass: "corp_table" },
                    [
                      _c("div", [_vm._v("株式会社キャンディルテクト")]),
                      _vm._v(" "),
                      _vm._m(5)
                    ]
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul_corp_outline" }, [
      _c("li", [
        _c("div", [_vm._v("販売業者")]),
        _vm._v(" "),
        _c("div", [_vm._v("ドゥーマンズ株式会社")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("責任者")]),
        _vm._v(" "),
        _c("div", [_vm._v("二宮 健一")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("住所")]),
        _vm._v(" "),
        _c("div", [_vm._v("東京都渋谷区代々木 3-28-6 いちご西参道ビル １階")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("電話番号")]),
        _vm._v(" "),
        _c("div", [_vm._v("03-5354-7671")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("メールアドレス")]),
        _vm._v(" "),
        _c("div", [_vm._v("info@domans.co.jp")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("ホームページ")]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.domans.co.jp/",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("https://www.domans.co.jp/")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の販売価格")]),
        _vm._v(" "),
        _c("div", [_vm._v("各商品ページをご参照ください。")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品以外の必要料金")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  ・配送料"),
          _c("br"),
          _vm._v(
            "\n                  ・（ご選択された場合）組立設置等のサービス料\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払方法")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  ・銀行振込、またはクレジットカード決済"),
          _c("br"),
          _vm._v(
            "\n                  ・掛け払い（審査を経た特定の法人のみ）\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  【 銀行振込 】"),
          _c("br"),
          _vm._v(
            "\n                  ご注文後、7日以内にお振込みをお願いいたします。"
          ),
          _c("br"),
          _vm._v("\n                  ※ 入金確認後の製作となります。"),
          _c("br"),
          _vm._v("\n                  【 クレジットカード決済 】"),
          _c("br"),
          _vm._v("\n                  ご注文時に決済となります。"),
          _c("br"),
          _vm._v("\n                  【 掛け払い 】"),
          _c("br"),
          _vm._v(
            "\n                  メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の引渡時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("返品・交換")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  オーダー家具のため、注文後のキャンセルはできません。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。"
          ),
          _c("br"),
          _vm._v("\n                  ・商品に瑕疵がある場合"),
          _c("br"),
          _vm._v(
            "\n                  ・商品説明と実際の商品が明らかに異なる場合"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・梱包の不備により配送時に商品が破損した場合"
          ),
          _c("br"),
          _vm._v("\n                  ・その他の商品の不具合\n                ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul_corp_outline" }, [
      _c("li", [
        _c("div", [_vm._v("販売業者")]),
        _vm._v(" "),
        _c("div", [_vm._v("ファニチャーメーカー株式会社 FurnitureMaker Inc.")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("責任者")]),
        _vm._v(" "),
        _c("div", [_vm._v("大瀧 夏彦")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("住所")]),
        _vm._v(" "),
        _c("div", [_vm._v("東京都渋谷区代々木 3-28-6 いちご西参道ビル １階")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("電話番号")]),
        _vm._v(" "),
        _c("div", [_vm._v("03-6300-9085")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("メールアドレス")]),
        _vm._v(" "),
        _c("div", [_vm._v("mmstyle@furnituremaker.co.jp")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("ホームページ")]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: "https://furnituremaker.co.jp/",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("https://furnituremaker.co.jp/")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の販売価格")]),
        _vm._v(" "),
        _c("div", [_vm._v("各商品ページをご参照ください。")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品以外の必要料金")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  ・配送料"),
          _c("br"),
          _vm._v(
            "\n                  ・（ご選択された場合）組立設置等のサービス料\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払方法")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  ・銀行振込、またはクレジットカード決済"),
          _c("br"),
          _vm._v(
            "\n                  ・掛け払い（審査を経た特定の法人のみ）\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  【 銀行振込 】"),
          _c("br"),
          _vm._v(
            "\n                  ご注文後、7日以内にお振込みをお願いいたします。"
          ),
          _c("br"),
          _vm._v("\n                  ※ 入金確認後の製作となります。"),
          _c("br"),
          _vm._v("\n                  【 クレジットカード決済 】"),
          _c("br"),
          _vm._v("\n                  ご注文時に決済となります。"),
          _c("br"),
          _vm._v("\n                  【 掛け払い 】"),
          _c("br"),
          _vm._v(
            "\n                  メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の引渡時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("返品・交換")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  オーダー家具のため、注文後のキャンセルはできません。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。"
          ),
          _c("br"),
          _vm._v("\n                  ・商品に瑕疵がある場合"),
          _c("br"),
          _vm._v(
            "\n                  ・商品説明と実際の商品が明らかに異なる場合"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・梱包の不備により配送時に商品が破損した場合"
          ),
          _c("br"),
          _vm._v("\n                  ・その他の商品の不具合\n                ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul_corp_outline" }, [
      _c("li", [
        _c("div", [_vm._v("販売業者")]),
        _vm._v(" "),
        _c("div", [_vm._v("株式会社みうら")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("責任者")]),
        _vm._v(" "),
        _c("div", [_vm._v("三浦 和久")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("住所")]),
        _vm._v(" "),
        _c("div", [_vm._v("山口県周南市野村３丁目24-1")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("電話番号")]),
        _vm._v(" "),
        _c("div", [_vm._v("0834-63-8811")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("メールアドレス")]),
        _vm._v(" "),
        _c("div", [_vm._v("miura@w-miura.co.jp")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("ホームページ")]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: "http://miura-wood.com",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("http://miura-wood.com")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の販売価格")]),
        _vm._v(" "),
        _c("div", [_vm._v("各商品ページをご参照ください。")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品以外の必要料金")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  ・配送料"),
          _c("br"),
          _vm._v(
            "\n                  ・（ご選択された場合）組立設置等のサービス料\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払方法")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  ・銀行振込、またはクレジットカード決済"),
          _c("br"),
          _vm._v(
            "\n                  ・掛け払い（審査を経た特定の法人のみ）\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  【 銀行振込 】"),
          _c("br"),
          _vm._v(
            "\n                  ご注文後、7日以内にお振込みをお願いいたします。"
          ),
          _c("br"),
          _vm._v("\n                  ※ 入金確認後の製作となります。"),
          _c("br"),
          _vm._v("\n                  【 クレジットカード決済 】"),
          _c("br"),
          _vm._v("\n                  ご注文時に決済となります。"),
          _c("br"),
          _vm._v("\n                  【 掛け払い 】"),
          _c("br"),
          _vm._v(
            "\n                  メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の引渡時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("返品・交換")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  オーダー家具のため、注文後のキャンセルはできません。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。"
          ),
          _c("br"),
          _vm._v("\n                  ・商品に瑕疵がある場合"),
          _c("br"),
          _vm._v(
            "\n                  ・商品説明と実際の商品が明らかに異なる場合"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・梱包の不備により配送時に商品が破損した場合"
          ),
          _c("br"),
          _vm._v("\n                  ・その他の商品の不具合\n                ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul_corp_outline" }, [
      _c("li", [
        _c("div", [_vm._v("販売業者")]),
        _vm._v(" "),
        _c("div", [_vm._v("アクシス株式会社")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("責任者")]),
        _vm._v(" "),
        _c("div", [_vm._v("彦坂 充宏")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("住所")]),
        _vm._v(" "),
        _c("div", [_vm._v("大阪市西区南堀江2-13-26")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("電話番号")]),
        _vm._v(" "),
        _c("div", [_vm._v("06-6536-2030")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("メールアドレス")]),
        _vm._v(" "),
        _c("div", [_vm._v("spc@ce-fit.com")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("ホームページ")]),
        _vm._v(" "),
        _c("div", [
          _c("div", [
            _c(
              "a",
              {
                attrs: {
                  href: "https://olis.group/corp-axis/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [_vm._v("https://olis.group/corp-axis/")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の販売価格")]),
        _vm._v(" "),
        _c("div", [_vm._v("各商品ページをご参照ください。")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品以外の必要料金")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  無し（配送料は商品代金に含まれます）\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払方法")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  ・銀行振込、またはクレジットカード決済"),
          _c("br"),
          _vm._v(
            "\n                  ・掛け払い（審査を経た特定の法人のみ）\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  【 銀行振込 】"),
          _c("br"),
          _vm._v(
            "\n                  ご注文後、7日以内にお振込みをお願いいたします。"
          ),
          _c("br"),
          _vm._v("\n                  ※ 入金確認後の製作となります。"),
          _c("br"),
          _vm._v("\n                  【 クレジットカード決済 】"),
          _c("br"),
          _vm._v("\n                  ご注文時に決済となります。"),
          _c("br"),
          _vm._v("\n                  【 掛け払い 】"),
          _c("br"),
          _vm._v(
            "\n                  メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の引渡時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("返品・交換")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  オーダー家具のため、注文後のキャンセルはできません。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。"
          ),
          _c("br"),
          _vm._v("\n                  ・商品に瑕疵がある場合"),
          _c("br"),
          _vm._v(
            "\n                  ・商品説明と実際の商品が明らかに異なる場合"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・梱包の不備により配送時に商品が破損した場合"
          ),
          _c("br"),
          _vm._v("\n                  ・その他の商品の不具合\n                ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul_corp_outline" }, [
      _c("li", [
        _c("div", [_vm._v("販売業者")]),
        _vm._v(" "),
        _c("div", [_vm._v("株式会社テクマ")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("責任者")]),
        _vm._v(" "),
        _c("div", [_vm._v("彦坂 充宏")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("住所")]),
        _vm._v(" "),
        _c("div", [_vm._v("兵庫県丹波篠山市吹上１")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("電話番号")]),
        _vm._v(" "),
        _c("div", [_vm._v("079-552-5498")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("メールアドレス")]),
        _vm._v(" "),
        _c("div", [_vm._v("spc@ce-fit.com")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("ホームページ")]),
        _vm._v(" "),
        _c("div", [
          _c("div", [
            _c(
              "a",
              {
                attrs: {
                  href: "https://olis.group/corp-tecma/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [_vm._v("https://olis.group/corp-tecma/")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の販売価格")]),
        _vm._v(" "),
        _c("div", [_vm._v("各商品ページをご参照ください。")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品以外の必要料金")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  無し（配送料は商品代金に含まれます）\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払方法")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  ・銀行振込、またはクレジットカード決済"),
          _c("br"),
          _vm._v(
            "\n                  ・掛け払い（審査を経た特定の法人のみ）\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  【 銀行振込 】"),
          _c("br"),
          _vm._v(
            "\n                  ご注文後、7日以内にお振込みをお願いいたします。"
          ),
          _c("br"),
          _vm._v("\n                  ※ 入金確認後の製作となります。"),
          _c("br"),
          _vm._v("\n                  【 クレジットカード決済 】"),
          _c("br"),
          _vm._v("\n                  ご注文時に決済となります。"),
          _c("br"),
          _vm._v("\n                  【 掛け払い 】"),
          _c("br"),
          _vm._v(
            "\n                  メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("商品の引渡時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("返品・交換")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  オーダー家具のため、注文後のキャンセルはできません。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。"
          ),
          _c("br"),
          _vm._v("\n                  ・商品に瑕疵がある場合"),
          _c("br"),
          _vm._v(
            "\n                  ・商品説明と実際の商品が明らかに異なる場合"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・梱包の不備により配送時に商品が破損した場合"
          ),
          _c("br"),
          _vm._v("\n                  ・その他の商品の不具合\n                ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul_corp_outline" }, [
      _c("li", [
        _c("div", [_vm._v("販売業者")]),
        _vm._v(" "),
        _c("div", [_vm._v("株式会社キャンディルテクト")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("責任者")]),
        _vm._v(" "),
        _c("div", [_vm._v("三浦 翔")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("住所")]),
        _vm._v(" "),
        _c("div", [_vm._v("東京都江東区常盤1-2-5")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("電話番号")]),
        _vm._v(" "),
        _c("div", [_vm._v("03-5625-4587")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("メールアドレス")]),
        _vm._v(" "),
        _c("div", [_vm._v("te_hp@candeal.co.jp")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("ホームページ")]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: "https://candeal-tect.co.jp",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("https://candeal-tect.co.jp")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("サービスの販売価格")]),
        _vm._v(" "),
        _c("div", [_vm._v("各商品ページをご参照ください。")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("サービス以外の必要料金")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  組立設置オプションには以下の費用が発生します。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・組立技術料：組立作業費および副資材、簡易養生材など。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・諸経費：交通費、燃料代など。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払方法")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  ・銀行振込、またはクレジットカード決済"),
          _c("br"),
          _vm._v(
            "\n                  ・掛け払い（審査を経た特定の法人のみ）\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("支払時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                  【 銀行振込 】"),
          _c("br"),
          _vm._v(
            "\n                  ご注文後、7日以内にお振込みをお願いいたします。"
          ),
          _c("br"),
          _vm._v("\n                  【 クレジットカード決済 】"),
          _c("br"),
          _vm._v("\n                  ご注文時に決済となります。"),
          _c("br"),
          _vm._v("\n                  【 掛け払い 】"),
          _c("br"),
          _vm._v(
            "\n                  メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いをお願いいたします。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("サービスの開始・完成時期")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  工事の開始時期及び完成時期は、別途お客様と合意した時期といたします。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ※地域（離島、遠隔地等）または時期（年末年始・夏季休業等）によっては通常より日数をいただく場合がございます。\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("ご注文のキャンセル")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  組立設置サービス契約の締結後は当該契約の解除（キャンセル）及び代金の返金はできません。"
          ),
          _c("br"),
          _vm._v(
            "\n                  詳細は利用規約第１１条をご覧ください。\n                "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eba2327", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eba2327","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcTokutei.vue
// module id = null
// module chunks = 